export default __webpack_public_path__ + "b985b9be0d8fb90e716de778d78fc367.svg";